import { Injectable } from "@angular/core";
import { Apollo, QueryRef } from "apollo-angular";
import { PartnerInterface } from "./definitions/partner-interface";
import partnerListQuery from "./queries/partners-list";
import { ListServiceBase } from "../../../classes/list-service-base";
import { ErrorsInterface } from "../errors/errors-interface";

interface PartnerListResponse {
  partner: {
    list: {
      output: Array<PartnerInterface>;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class PartnerListService extends ListServiceBase {
  constructor(private apollo: Apollo) {
    super();
  }

  getQuery(variables): QueryRef<PartnerListResponse> {
    return this.apollo.watchQuery<PartnerListResponse>({
      query: partnerListQuery,
      fetchPolicy: "network-only",
    });
  }
}
